import React from 'react';
import { Card, CardContent, Box, Typography, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// Единая карточка метрики — заменяет 3 независимые реализации (Dashboard
// MetricCard/SectionCard, AdminUsers Paper+ButtonBase grid).
//
// Правило «Мягкой аналитики»: цвет статуса — только маленький чип дельты,
// НИКОГДА заливка всей карточки (это то, что не понравилось в дашборде
// конкурента). `delta` необязателен и не должен передаваться, если для
// него нет настоящего значения с backend — см. use-case Dashboard в Этапе 2.
const StatCard = ({ icon, label, value, delta, helperText }) => {
  const deltaPositive = delta?.direction === 'up';
  const deltaNegative = delta?.direction === 'down';

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 0.5 }} noWrap>
              {label}
            </Typography>
            <Typography variant="h4" sx={{ fontSize: '1.75rem', lineHeight: 1.2 }}>
              {value}
            </Typography>
            {helperText && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                {helperText}
              </Typography>
            )}
            {delta && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={{
                  mt: 1,
                  display: 'inline-flex',
                  px: 1,
                  py: 0.25,
                  borderRadius: '8px',
                  bgcolor: (theme) =>
                    alpha(
                      deltaPositive
                        ? theme.palette.success.main
                        : deltaNegative
                        ? theme.palette.error.main
                        : theme.palette.text.secondary,
                      theme.palette.mode === 'dark' ? 0.18 : 0.12
                    ),
                  color: deltaPositive ? 'success.main' : deltaNegative ? 'error.main' : 'text.secondary',
                }}
              >
                {deltaPositive && <ArrowUpwardIcon sx={{ fontSize: 14 }} />}
                {deltaNegative && <ArrowDownwardIcon sx={{ fontSize: 14 }} />}
                <Typography variant="caption" sx={{ fontWeight: 700 }}>
                  {delta.text}
                </Typography>
              </Stack>
            )}
          </Box>
          {icon && (
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.18 : 0.1),
                color: 'primary.main',
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StatCard;
